export default __webpack_public_path__ + "static/media/meeting.8f1dc200.svg";